import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import auth from './modules/auth/auth';
import subscription from './modules/subscription';
import project from './modules/project';
import error from './modules/error/error';
import featureflags from "src/store/modules/featureflags";
import app from "src/store/modules/app";
import query from "src/store/modules/query/query";
import announcements from "src/store/modules/announcements/announcements";
import data from "src/store/modules/data/";
import appVersion from 'src/store/modules/version';
import * as getters from './getters';
import { updateSitesList, updateIntercomSubscription, updateIntercomUser, setIntercomVisibility } from './watchers';
// Make vue aware of Vuex
Vue.use(Vuex);
const store = new Store({
    getters: getters,
    modules: {
        auth: auth,
        subscription: subscription,
        project: project,
        error,
        featureflags,
        app: app,
        query: query,
        announcements: announcements,
        data: data,
        appVersion,
    },
    plugins: [
        updateSitesList,
        updateIntercomSubscription,
        updateIntercomUser,
        setIntercomVisibility,
    ],
    strict: false
});
export const useStore = () => store;
export default store;
